export const typeCtrlF1 = {
  id: 112,
  name: 'CTRL+F1',
};
export const typeCtrlF2 = {
  id: 113,
  name: 'CTRL+F2',
};
export const typeCtrlF3 = {
  id: 114,
  name: 'CTRL+F3',
};
export const typeCtrlF6 = {
  id: 117,
  name: 'CTRL+F6',
};
export const typeCtrlF7 = {
  id: 118,
  name: 'CTRL+F7',
};
export const typeCtrlF8 = {
  id: 119,
  name: 'CTRL+F8',
};
export const typeCtrlF9 = {
  id: 120,
  name: 'CTRL+F9',
};
export const typeCtrlF10 = {
  id: 121,
  name: 'CTRL+F10',
};
export const typeCtrlF11 = {
  id: 122,
  name: 'CTRL+F11',
};
export const typeCtrlF12 = {
  id: 123,
  name: 'CTRL+F12',
};
export const typeCtrlB = {
  id: 66,
  name: 'CTRL+B',
};
export const typeCtrlShiftF3 = {
  id: 114,
  name: 'CTRL+SHIFT+F3',
};
export const typeCtrlShiftF6 = {
  id: 117,
  name: 'CTRL+SHIFT+F6',
};
export const typeCtrlShiftF7 = {
  id: 118,
  name: 'CTRL+SHIFT+F7',
};
export const typeCtrlShiftF8 = {
  id: 119,
  name: 'CTRL+SHIFT+F7',
};
export const typeCtrlDel = {
  id: 46,
  name: 'CTRL+DEL',
};

const shortcuts = [
  typeCtrlF1,
  typeCtrlF2,
  typeCtrlF3,
  typeCtrlF6,
  typeCtrlF7,
  typeCtrlF8,
  typeCtrlF9,
  typeCtrlF10,
  typeCtrlF12,
  typeCtrlShiftF3,
  typeCtrlShiftF6,
  typeCtrlShiftF7,
  typeCtrlShiftF8,
  typeCtrlDel,
];

export default shortcuts;
